// extracted by mini-css-extract-plugin
export default {"boxContainer":"styles_boxContainer__DOUWP","text":"styles_text__wMb4p"};